import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FiUser } from 'react-icons/fi';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { css } from '@emotion/core';

import Button from '../../../shared/Button/Button';
import { primary_light, primary_s20_l95 } from '../../../shared/lib/colors';
import {
  createCoupon,
  loadUserCoupons,
} from '../../../../redux/modules/coupons';

import './InvitaUnAmico.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

class InvitaUnAmico extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inviting: false,
      email: '',
    };
  }

  componentDidMount() {
    if (!this.props.store.features.hasInvitaUnAmico) {
      browserHistory.push('/profilo');
    }
    this.props.loadUserCoupons();
    setTimeout(() => {
      const height = document.getElementById('firstColumn').clientHeight;
      this.setState({ height });
    }, 100);
  }

  handleCreateCoupon = () => {
    const now = moment().format();
    const futureMonth = moment(now)
      .add(1, 'M')
      .format();
    const couponInvitato = {
      invitingUser: this.props.user.data.email,
      invitedUser: this.state.email,
      storeId: this.props.storeId,
      name: 'Invita un amico',
      minAmount: this.props.store.funzionalita.couponInviteMinimumValue,
      maxUses: 1,
      discountFixed: this.props.store.funzionalita.couponInvitedUserValue,
      discountFixedInviting: this.props.store.funzionalita
        .couponInvitingUserValue,
      isEnabled: 1,
      startsAt: now,
      expiresAt: futureMonth,
      inviteType: 'Invitato',
    };
    this.props.createCoupon(couponInvitato);
  };

  handleChangeEmail = event => {
    this.setState({
      email: event.target.value,
    });
  };

  render() {
    const { primaryColor, coupons, store, uiVariantInputText } = this.props;
    const { userCoupons } = coupons;
    const filteredCoupons = userCoupons
      .filter(invite => !!invite.inviteType)
      .filter(invite =>
        invite.inviteType === 'Invitato'
          ? !!invite.isEnabled
          : invite.maxUses > 0
      );
    const { funzionalita } = store;

    const InvitaAmicoStyle = css`
      .input-email {
        border-radius: ${
          uiVariantInputText === '1'
            ? '12px'
            : uiVariantInputText === '3'
            ? '30px'
            : 0
        };
        /* &:focus {
          border-color: ${primaryColor}!important;
        } */
      }
      .scrolling-section {
        &::-webkit-scrollbar-track,
        &::-webkit-scrollbar {
          background-color: ${primary_light(primaryColor)};
        }
        &::-webkit-scrollbar-thumb {
          background-color: ${primaryColor};
        }
      }
      .coupon {
        background-color: ${primary_s20_l95(primaryColor)};
      }
    `;

    return (
      <div className="invita-un-amico" css={InvitaAmicoStyle}>
        <div className="row">
          <div id="firstColumn" className="col-lg-6 fit-content">
            <div
              className="title-container"
              style={{ color: this.props.primaryColor }}
            >
              Invita un amico e ricevete entrambi un buono sconto
            </div>
            <div className="image-container">
              <ImageDispatcher
                src="/static/images/invita-un-amico-placeholder.png"
                style={{ maxWidth: '70%' }}
              />
            </div>
            <div
              className="description-container"
              dangerouslySetInnerHTML={{
                __html: `Per ogni amico invitato che completerà l'acquisto riceverai €${funzionalita.couponInvitingUserValue} di buono sconto da spendere su una spesa minima di €${funzionalita.couponInviteMinimumValue}. <br>
              Inoltre, ogni tuo amico riceverà un buono sconto di €${funzionalita.couponInvitedUserValue} e per il suo primo acquisto.`,
              }}
            />
            <div className="input-container">
              <input
                defaultValue={this.state.email}
                onChange={this.handleChangeEmail}
                className="input-email"
                placeholder="Indirizzo email"
              />
              <Button
                disabled={this.state.email === ''}
                onClick={() => this.handleCreateCoupon()}
                className="btn btn-primary"
                style={{ backgroundColor: this.props.primaryColor }}
              >
                INVIA
              </Button>
            </div>
            <div className="error">{this.props.coupons.error}</div>
          </div>
          <div id="secondColumn" className="col-lg-6">
            <div id="invitedUserList">
              <div className="scrolling-section">
                {userCoupons && filteredCoupons.length > 0 ? (
                  filteredCoupons.map((invite, i) => (
                    <div
                      key={i}
                      className="invite-container"
                      style={{
                        borderBottom:
                          i !== userCoupons.length - 1 ? '1px solid #ddd' : '',
                      }}
                    >
                      <div className="avatar-container">
                        <FiUser
                          color={this.props.primaryColor}
                          size={28}
                          style={{ marginTop: 4 }}
                        />
                      </div>
                      <div className="user-data-container">
                        <div className="user-name">
                          {invite.invitingUser.split('.')[0]}
                        </div>
                        <div className="user-email">{invite.invitingUser}</div>
                      </div>
                      <div className="coupon-container">
                        {!!invite.isEnabled && (
                          <div
                            className="coupon-row"
                            style={{
                              opacity:
                                new Date() > new Date(invite.expiresAt)
                                  ? 0.5
                                  : 1,
                            }}
                          >
                            <div className="coupon">{invite.code}</div>
                            <div
                              className="coupon-value"
                              style={{ color: this.props.primaryColor }}
                            >
                              {'€ ' + invite.discountFixed}
                            </div>
                          </div>
                        )}
                        <div
                          className="coupon-status"
                          style={{
                            color: !invite.isEnabled
                              ? this.props.primaryColor
                              : new Date() > new Date(invite.expiresAt)
                              ? 'red'
                              : 'rgb(32, 178, 170)',
                          }}
                        >
                          {!invite.isEnabled
                            ? 'Invitato'
                            : new Date() > new Date(invite.expiresAt)
                            ? 'Scaduto'
                            : 'Valido'}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="empty-container">
                    <div className="placeholder" style={{ color: '#bbb' }}>
                      Invita i tuoi amici e visualizza qui la lista dei tuoi
                      invitati
                    </div>
                    <ImageDispatcher
                      src="/static/images/invita-un-amico-grey.png"
                      style={{ maxWidth: '90%', backgroundColor: primaryColor }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    store: state.store.data,
    storeId: state.store.data.storeId,
    user: state.user,
    siteName: state.store.data.datiFarmacia.siteName,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    coupons: state.coupons,
    uiVariantInputText: state.store.data.uiVariants.inputText,
  };
};

export default connect(mapStateToProps, { createCoupon, loadUserCoupons })(
  InvitaUnAmico
);
